const ShipmentTypeEnum = {
  THIRDPARTYSHIPMENT: 'ThirdPartyShipment',
  SALEORDER: 'SaleOrder',
  RESTOCK: 'Restock',
};

export default ShipmentTypeEnum;
